import { ajax } from "rxjs/ajax";
import { Observable } from "rxjs";
import { OrganizationKeyName } from "../model/Organization";
import { BeaconListSuccessResponse } from "./api-response/BeaconListSuccessResponse";
import { getAuthAndDefaultHeaders } from "./apiConsts";
import * as queryString from "query-string";
import { map } from "rxjs/operators";

export class ApiBeacon {
  constructor(private apiEndpoint: string) {}

  listByOrganization(
    token: string,
    organization: OrganizationKeyName,
    filters: any,
    page: number
  ): Observable<BeaconListSuccessResponse> {
    let params = {
      page,
      ...(filters || {}),
    };

    const filtersStr =
      "?" + queryString.stringify(params, { arrayFormat: "bracket" });

    return ajax({
      url: `${this.apiEndpoint}/organizations/${organization}/beacon/status${filtersStr}`,
      method: "GET",
      headers: getAuthAndDefaultHeaders(token),
    }).pipe(map((x) => x.response));
  }
}
